__webpack_public_path__=process.env.ASSET_PATH;
      window['__webpack_public_path__']=process.env.ASSET_PATH;
      /**** injected __index_injected__.js ****/ 
      ;
      